import React from 'react';

export function TriangleWarningIcon({ fillColor }: { fillColor: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 16 13"
      aria-hidden={true}
    >
      <path
        fill={fillColor}
        fillRule="evenodd"
        d="M9.73 1a2 2 0 0 0-3.46 0l-5.2 9a2 2 0 0 0 1.73 3h10.4a2 2 0 0 0 1.73-3l-5.2-9Zm-1.7 3.98C7.4 4.98 6.98 4.54 7 4c-.02-.58.4-1 1.04-1s1.04.44 1.06 1c0 .52-.42.98-1.07.98Zm.02 6.34a.99.99 0 0 1-.99-.98v-3.6a.99.99 0 0 1 1.98 0v3.6c0 .54-.44.98-.99.98Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
